/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="78.36"
        height="88.92"
        viewBox="0 0 78.36 88.92"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M12.69.96c-2.33 1.51-4.57 3-6.76 4.65a14.57 14.57 0 0 0-5.75 14C5.06 50.88 24.9 75.89 54.29 87.82a14.58 14.58 0 0 0 15-2.38c2.07-1.76 4.09-3.58 6.09-5.49a6.13 6.13 0 0 0 .28-8.59L64.84 59.6a7.14 7.14 0 0 0-10.08-.44l-.22.2-4.45 4.43-.22.19-.21.16a2.52 2.52 0 0 1-3.32 0 107.45 107.45 0 0 1-24.87-31.35 2.56 2.56 0 0 1 .61-3.13l.22-.17.35-.26 5.38-3.36a7.1 7.1 0 0 0 2.32-9.77l-.05-.07-1.59-2.35-7.53-11A6.17 6.17 0 0 0 12.95.85Zm6.36 3.11 9 13.16a4.61 4.61 0 0 1-1.21 6.42l-.18.11-5.35 3.3-.23.15-.22.16-.17.14a5 5 0 0 0-1.46 6.45 109.84 109.84 0 0 0 25.48 32l.19.15a5 5 0 0 0 6.21 0l.16-.13h-.06a4.16 4.16 0 0 0 .64-.54l4.46-4.43a4.66 4.66 0 0 1 6.58.05.57.57 0 0 1 .11.11l10.78 11.74a3.64 3.64 0 0 1-.16 5.09q-3 2.81-6 5.39a12.07 12.07 0 0 1-12.4 2C26.66 73.89 7.4 49.61 2.65 19.2A12 12 0 0 1 7.41 7.62c2.15-1.57 4.35-3.09 6.64-4.57a3.66 3.66 0 0 1 5 1Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M57.14 39.96a12.12 12.12 0 0 0-9.94-12.2 1.25 1.25 0 1 1 .24-2.48h.17a14.58 14.58 0 0 1 12 14.71v.33a1.25 1.25 0 1 1-2.5 0Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M46.79 17.25a1.26 1.26 0 0 1 1.44-1 24.84 24.84 0 0 1 20.41 25.31v.88a1.2 1.2 0 0 1-1 .64h-.17A1.23 1.23 0 0 1 66.1 42v-.61a22.35 22.35 0 0 0-18-22.63l-.34-.06a1.25 1.25 0 0 1-.97-1.45Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M78.28 43.53a1.23 1.23 0 0 1-1.3 1.2 1.25 1.25 0 0 1-1.2-1.3v-.13C76.9 26.96 64.65 11.58 48.49 8.96a1.252 1.252 0 0 1 .41-2.47c17.25 2.84 30.32 19.09 29.41 36.52Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'TelephoneWithOutgoingSoundIcon';

export default Icon;
